document.addEventListener(
  "teeinblue-event-after-cart-added",
  async function () {
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    let sectionsToRender = cart
      .getSectionsToRender()
      .map((section) => section.id)
      .join(",");
    const sections = await fetch(`?sections=${sectionsToRender}`).then(
      (response) => response.json()
    );
    let cartContent = await fetch(`${Shopify.routes.root}cart.js`).then(
      (response) => response.json()
    );

    if (!cart || !sections || !cartContent) {
      return;
    }

    cartContent = {
      ...cartContent,
      key: cartContent.items?.at(0)?.key ?? "",
      sections: sections,
    };

    cart.renderContents(cartContent);
    if (cartContent.items.length === 0) {
      cart.classList.add("is-empty");
    }
  }
);